module.exports = __webpack_public_path__ + "media/ok1.e35abd3f.mp3";